import { AxiosResponse } from 'axios';
import FilterTagPrintingList, {
  FilterTagPrintingListForKlok,
  GenerateTagToPrintProps,
} from '~/@core/domain/filters/tag/FilterTagPrintingList';
import { endpoints } from '~/constants/endpoints';
import { GfpType } from '~/domain/enum/gfp/gfpType.enum';
import { TagDataToPrintProps } from '~/domain/model/TagPrinting/TagDataToPrint';
import { fetchPrintedListParams } from '~/store/modules/tagPrinting/apiCalls';
import api, { apiGfp } from '../api';

export const findManyByProducts = async ({
  pageSize,
  pageNumber,
  viewByCustomer = false,
  ...params
}: FilterTagPrintingList) => {
  let url = `${endpoints.tagPrinting.base}/${viewByCustomer ? 'customer' : 'product'}`;
  const entries = Object.entries({ ...params });

  url += `?PageSize=${pageSize}&PageNumber=${pageNumber}`;
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of entries) {
    if (value !== undefined && value !== null) {
      url += `&${key}=${value}`;
    }
  }
  const response = await api.get(url);
  return response.data;
};

export const generateTagToPrint = async (params: GenerateTagToPrintProps) => {
  const response = await api.post(`${endpoints.tagPrinting.base}`, params);
  return response;
};

export const getTagDataToPrint = async (tagIds: number[]) => {
  let params = '';

  tagIds.forEach((tag, index) => {
    params += `${index > 0 ? '&' : '?'}tagIds=${tag}`;
  });

  const response = await api.get<number, AxiosResponse<TagDataToPrintProps[]>>(
    `${endpoints.tagPrinting.base}/tag${params}`,
  );
  return response;
};

export const getTagDataToPrintItem = async (tagId: number[]) => {
  let params = '';

  tagId.forEach((tag, index) => {
    params += `${index > 0 ? '&' : '?'}tagId=${tag}`;
  });

  const response = await api.get<number, AxiosResponse<TagDataToPrintProps[]>>(
    `${endpoints.tagPrinting.base}/tag-item${params}`,
  );
  return response;
};

export const getPrintedList = async (props: {
  siteId: number;
  pageSize: number;
  pageNumber: number;
}) => {
  const { data } = await api.get(
    `${endpoints.tagPrinting.base}/printed?Data.SiteId=${props.siteId}&PageNumber=${props.pageNumber}&PageSize=${props.pageSize}`,
  );

  return data;
};

export const getPrintedListWithFilter = async (params: fetchPrintedListParams) => {
  const { siteId, deliveryDate, type, customerId, tagCode } = params.Data;
  let url = `${endpoints.tagPrinting.base}/printed${
    type === GfpType.Klok ? '/klok-reservation' : '/intermediation-orders'
  }?Data.SiteId=${siteId}&PageNumber=${params.PageNumber}&PageSize=${params.PageSize}`;

  if (deliveryDate) {
    url += `&Data.DeliveryDate=${deliveryDate}`;
  }

  if (type) {
    url += `&Data.Type=${type}`;
  }
  if (customerId) {
    url += `&Data.CustomerId=${customerId}`;
  }
  if (tagCode) {
    url += `&Data.TagCode=${tagCode}`;
  }

  const { data } = await api.get(url);

  return data;
};

export const deletePrintedListItem = async (tagIds: React.Key[]) => {
  const itemDelete = await api.delete(`${endpoints.tagPrinting.base}/tag`, {
    data: tagIds,
  });
  return itemDelete;
};

export const deletePrintedItem = async (tagIds: React.Key[]) => {
  const itemDelete = await api.delete(`${endpoints.tagPrinting.base}/tag-item`, {
    data: tagIds,
  });
  return itemDelete;
};

export const updateOrders = async (
  items: {
    saleTransactionId: number;
    origin: string;
    observation: string;
    obs1Id: string;
    obs2Id: string;
    packingId: number;
  }[],
) => {
  const response = await apiGfp.post<number, AxiosResponse<TagDataToPrintProps[]>>(
    `sale-transaction-custom`,
    items,
  );
  return response;
};

export const findManyKlokTagsByCustomers = async (params: FilterTagPrintingListForKlok) => {
  // Cria a URL base com os parâmetros de paginação
  let url = 'klokReservation/tag-print/customers';
  url += `?PageSize=${params.PageSize || 100}&PageNumber=${params.PageNumber || 1}`;

  // Processa as propriedades do objeto Data usando Object.entries + forEach
  if (params.Data) {
    Object.entries(params.Data).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        url += `&Data.${key}=${encodeURIComponent(value)}`;
      }
    });
  }

  const response = await apiGfp.get(url);
  return response.data;
};

export const findManyKlokTagsByProducts = async (params: FilterTagPrintingListForKlok) => {
  // Cria a URL base com os parâmetros de paginação
  let url = 'klokReservation/tag-print/products';
  url += `?PageSize=${params.PageSize || 100}&PageNumber=${params.PageNumber || 1}`;

  // Processa as propriedades do objeto Data usando Object.entries + forEach
  if (params.Data) {
    Object.entries(params.Data).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        url += `&Data.${key}=${encodeURIComponent(value)}`;
      }
    });
  }

  const response = await apiGfp.get(url);
  return response.data;
};
